export const nursestatuses = [
                        "Appointment Deferred by Client",
                        "Appointment Unkept by Client",
                        "Closed - Client no longer interested",
                        "Closed - Client refused appointment",
                        "Closed - Client seen by another provider",
                        "Closed - Client uncontactable",
                        "Closed - Duplicate",
                        "Closed - Referred to doctor or clinic",
                        "Closed - Referred to lab",
                        "Contact Unsuccessful - Will Retry",
                        "Customer Uncontactable - Refer to broker",
                        "Rejected - Out of service area",
                        "Rejected - Schedule too busy",
                        "Rejected - Unavailable",
                        "Results Not Received",
                        "Distributed Successfully",
                        "Other",
                    ];

function Stat (key, label){
    this.key = key;
    this.label = label;
    // this.field1 = field1;
    // this.field2 = field2;
    // this.field3 = field3;
}

export const AdminStatus = new Object();
AdminStatus.new = new Stat(0, "New Cases");
//AdminStatus.actreq = new Stat(101, "Action Required");
//AdminStatus.notsubmitted = new Stat(102, "Results Outstanding");
AdminStatus.assigned = new Stat(201, "Assigned Cases");
AdminStatus.aptmade = new Stat(202, "Appointment Made");
AdminStatus.aptresc = new Stat(203, "Appointment Rescheduled");
AdminStatus.aptcomp = new Stat(204, "Appointment Completed");
AdminStatus.completed = new Stat(999, "Ready For Distribution");
//AdminStatus.closed = new Stat(-1, "Cancelled Cases");

export const StatusList = {
    0: "New Case", 101: "Action Required", 102: "Results Outstanding", 
    201: "Case Assigned", 202: "Appointment Made", 203: "Appointment Rescheduled", 204: "Appointment Completed",
    999: "Ready For Distribution", '-1': "Cancelled Cases"
}

